module.exports = __webpack_public_path__ + "static/media/193.4428c8c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/193.jpg
// module id = 953
// module chunks = 0